'use strict';

/**
 * @ngdoc function
 * @name sharedModule.directive:needAssistance
 * @description
 * # Need Assistance
 * Directive of the sharedModule
 */
(function (angular, window, undefined) {
  function needAssistance($window, $rootScope, $location, modalFactory) {
    'ngInject'

    var directive = {
      link: link,
      restrict: 'E',
      scope: {
        
      },
      templateUrl: (window.location.hostname === 'localhost' ? '/app/' : '') + 'views/shared/needAssistance.html',
      bindToController: true,
      controller: controller,
      controllerAs: 'needAssistanceCtrl'
    };
    return directive;

    function controller() {
      'ngInject';//must be first line in function... needed by ng-annotate
    }

    function link(scope, element, attrs) {
      var vm = directive.controllerAs ? scope[directive.controllerAs] : scope;

      vm.contactUs = function () {
        modalFactory.showModal({
          bodyTemplateUrl: (window.location.hostname === 'localhost' ? '/app/' : '') + 'views/shared/contactUsModal.html',
          controller: 'ModalController',
          modalcss: 'small',
          inputs: {
            title: 'Contact Us'
          }
        })
      };
    }
  }
  angular.module('sharedModule')
    .directive('needAssistance', needAssistance);
})(angular, window);
